/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { Injectable } from "@angular/core";
import { clientUtil } from "@html-core";
import { HorizonClientInfo, ClientInfoService } from "../../../shared/common/service/client-info.service";
import { HTML5ClientInfoServiceV2 } from "./html5-client-info-v2.service";

const LOG_LEVEL: string = "logLevel";
@Injectable()
export class HTML5ClientInfoService extends ClientInfoService {
   constructor(private html5ClientInfoServiceV2: HTML5ClientInfoServiceV2) {
      super();
   }
   public getConfigInfo = async (): Promise<HorizonClientInfo> => {
      if (clientUtil.isTitanClient()) {
         this.clientInfo = await this.html5ClientInfoServiceV2.getClientInfo();
      } else {
         if (!this.clientInfo) {
            this.clientInfo = await $.ajax({
               type: "GET",
               url: "../info.jsp",
               dataType: "json",
               async: true,
               cache: false
            });
         }
      }

      // Provide a debug method to change Log Level inside the browser.
      if (window && window.localStorage) {
         const logLevel = window.localStorage.getItem(LOG_LEVEL);
         if (logLevel && typeof logLevel === "string" && Number.isNaN(logLevel)) {
            if (Number(logLevel) >= 0 && Number(logLevel) <= 4) {
               this.clientInfo.logLevel = Number(logLevel);
            }
         }
      }
      return this.generateClientInfo(this.clientInfo);
   };
}
